<template>
    <div>
    <document-group-table :doc-type="docType"></document-group-table></div>
</template>

<script>
    const documentGroupTable =() => import ('@/components/orgApps/DocumentGroup/DocumentGroupTable');

    export default {
        name: "documentGroupDash",
        props:['docType'],
        components: {
            documentGroupTable
        }
    }
</script>

<style scoped>

</style>